module.exports = __webpack_public_path__ + "5c00611c960a5ba2dd775b19f5a37483.svg";